import { Action } from '@ngrx/store';
import { ConnectionData } from '../../../global/interfaces';

export enum ActionTypes {
    LOAD_CONNECTIONS = '[My Connections] Load Connections Action',
    LOAD_CONNECTIONS_SUCCESS = '[My Connections] Load Connections Success Action',
    LOAD_CONNECTIONS_FAILED = '[My Connections] Load Connections Failed'
}

export class LoadConnectionsAction implements Action {
    readonly type = ActionTypes.LOAD_CONNECTIONS;
}

export class LoadConnectionsSuccessAction implements Action {
    readonly type = ActionTypes.LOAD_CONNECTIONS_SUCCESS;

    public constructor(public payload: ConnectionData[]) {
    }
}

export class LoadConnectionsFailedAction implements Action {
    readonly type = ActionTypes.LOAD_CONNECTIONS_FAILED;

    public constructor(public payload: any) {
    }
}

export type Actions =
    LoadConnectionsAction |
    LoadConnectionsSuccessAction |
    LoadConnectionsFailedAction;
